import { Container } from '@material-ui/core';
import { makeStyles } from '@material-ui/styles';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import { getTasksRequest } from '../../store/actions/taskActions';
import IletisimDetay from './ContactDetail';
import { getUser } from 'src/utils/Common';

const useStyles = makeStyles(theme => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  IletisimDetay: {
    marginTop: theme.spacing(1)
  }
}));

const ServisIletisim = props => {
  const classes = useStyles();
  const { t } = useTranslation('service_contact');
  const SessionUser = getUser();
  var TitleApp = "Sirius CRM";
  if (SessionUser.Role === 2) {
    TitleApp = "Sirius Partner"
  }
  return (
    <Page className={classes.root} title={TitleApp}>
      <Container maxWidth="lg">
        <Header />
        <IletisimDetay className={classes.IletisimDetay} />
      </Container>
    </Page>
  );
};

export default connect(state => ({ tasks: state.tasks1 }), {
  getTasksRequest
})(ServisIletisim);
